<template>
    <div class="gallery-message">
        <div class="cards" ref="cardContainer">
            <div class="prev" @click="prevCard" v-if="currentIndex !== 0">
                <md-button class="md-icon-button">
                    <md-icon>chevron_left</md-icon>
                </md-button>
            </div>
            <GalleryImageCard
                v-for="(card, index) in cards"
                :key="'card-' + index"
                :card="card"
                :on-card-updated="(payload) => onCardUpdated(index, payload)"
                :show-add-card="index === cards.length - 1"
                :on-add-card="onAddCard"
                ref="cardRefs"
                :current="index === currentIndex"
                :remove-card-enabled="cards.length > 1"
                :remove-card="() => removeCardWithIndex(index)"
                :flatted-diagram="flattedDiagram"
                :preview-mode="previewMode"
                :show-attributes="showAttributes"
                :show-emoji="showEmoji"
                :show-emoji-picker="showEmojiPicker"
            />
            <div class="next" v-if="!previewMode">
                <md-button class="md-icon-button" @click="nextCard" v-if="currentIndex !== cards.length - 1">
                    <md-icon>chevron_right</md-icon>
                </md-button>
            </div>
        </div>
    </div>
</template>

<script>
import AttributesContext from "../../AttributesContext";
import log2 from "../../../../../../../utils/log2";
import _ from "lodash";
import GalleryImageCard from "./GalleryImageCard";
import { generateRandomId } from "../../../../../../../utils/session";

const log = log2("GalleryMessageEditor");
export default {
    name: "GalleryMessageEditor",
    props: [
        "cards",
        "onUpdated",
        "showAttributes",
        "onAttributeAdded",
        "flattedDiagram",
        "whatsappMode",
        "allowedAttributes",
        "previewMode",
        "showAttributes",
        "showEmoji",
        "showEmojiPicker",
    ],
    components: { AttributesContext, GalleryImageCard },
    data() {
        return {
            items: this.cards,
            currentIndex: 0,
        };
    },
    methods: {
        removeCardWithIndex(index) {
            this.items.splice(index, 1);
            if (index === this.currentIndex) {
                this.currentIndex = Math.max(0, this.currentIndex - 1);
            }
        },
        onAddCard() {
            log("onAddCard");
            this.onUpdated({
                cards: [
                    ...this.items,
                    {
                        id: generateRandomId(),
                        imageUrl: null,
                        assetId: null,
                        title: null,
                        description: null,
                        buttons: [
                            {
                                id: generateRandomId(),
                                title: "Button",
                                type: "SEND_MESSAGE",
                                payload: {},
                                actions: [], //{type: "SET_ATTRIBUTE", payload: {attribute:"custom",value:1} },
                            },
                        ],
                    },
                ],
            });
            setTimeout(() => {
                this.currentIndex = this.items.length - 1;
                this.scrollToCard();
            }, 100);
        },
        onCardUpdated(index, payload) {
            log("onCardUpdated", { index, payload });
            Object.keys(payload).forEach((key) => {
                this.items[index][key] = payload[key];
            });
            // this.onUpdated({ cards: this.items });
        },
        scrollToCard() {
            log("scrollToCard", this.$refs.cardContainer);
            const isLast = this.currentIndex === this.items.length - 1;
            this.$refs.cardContainer.scroll(240 * this.currentIndex - (isLast ? 0 : 80), 0);
            // const card = this.$refs.cardRefs[this.currentIndex];
            // if (card) {
            //     log("scroll", card);
            //     card.$el.scrollIntoView({ behavior: "smooth", block: "end" });
            // }
        },
        nextCard() {
            if (this.currentIndex < this.items.length - 1) {
                this.currentIndex++;
                this.scrollToCard();
            }
        },
        prevCard() {
            if (this.currentIndex > 0) {
                this.currentIndex--;
                this.scrollToCard();
            }
        },
    },
    mounted() {
        log("mounted", this.cards);
    },
    watch: {
        items: {
            handler(items) {
                log("watch items", items);
                this.onUpdated({ cards: items });
            },
            deep: true,
        },
        cards(newValue) {
            log("watch texts", newValue);
            if (!_.isEqual(newValue, this.items)) {
                this.currentIndex = 0;
                this.items = newValue;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.gallery-message {
    .cards {
        display: flex;
        flex-wrap: nowrap;
        gap: 20px;
        overflow: hidden;
        width: 100%;
        scroll-behavior: smooth;
        //border: 1px solid red;

        .prev,
        .next {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 40px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            .md-button {
                background: white;
                box-shadow: 0 0 15px 0 rgb(0 0 0 / 50%);

                .md-icon {
                    font-size: 35px !important;
                    color: #448aff;
                }
            }

            //border: 1px solid green;
        }

        .prev {
            left: 0;
        }

        .next {
            right: 0;
        }
    }

    .controls {
        border: 1px solid green;
    }
}
</style>
